import React, { Component } from 'react';
import Sidebar from './Sidebar.js';
import brandLogo from '../images/brand-logo-inverse-light.png';
import lang_en from '../images/lang_en.png';
import lang_es from '../images/lang_es.png';
import { LANG } from '../App.js';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

class Navbar extends Component {

  renderSidebar = () => {
    return (
      <Sidebar
        getTokenId={this.props.getTokenId}
        getTokenSession={this.props.getTokenSession}
        handleErrorResponse={this.props.handleErrorResponse}
        post={this.props.post}
        setUser={this.props.setUser}
        user={this.props.user}
        handleLogoutClick={this.props.handleLogoutClick} />
    );
  }

  renderNotificacion = (notificacion) => {
    const { t } = this.props;
    const profile = notificacion.foto ? "https://img.iosoffices.com/img/iosfera/usuarios/" + notificacion.foto
      : "https://img.iosoffices.com/img/iosfera/usuarios/default.jpg";
    return (
      <div className="notificacion">
        <div className="notificacion-container">
          <div className="notificacion-picture">
            <div className="profile">
              <div className="badge-wrapper">
                <img
                  className="cover-img__image relative w-full h-full object-cover img-responsive"
                  alt={t('dashboard.profile.img_user')}
                  src={profile}
                  loading="lazy" data-embed-id="cover-image" />
              </div>
            </div>
          </div>
          <div className="notificacion-message">
            <a>
              {notificacion.nombre} {notificacion.apellido} , {notificacion.puesto} de {notificacion.empresa}
            </a>
            <a>{notificacion.estatus == "Aceptada" ? (
              " Acepto la solicitud de conexion"
            ) : (
              " te envio una solicitud de conexion"
            )}</a>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { t } = this.props;
    const notificaciones = this.props.user.notificaciones
    return (
      <nav className="navbar navbar-default navbar-fixed-top">
        <div className="navbar-header">
          <button
            className="navbar-toggle"
            data-target=".navbar-collapse"
            data-toggle="collapse"
            type="button">
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <div className="navbar-brand">
            <Link className="nav-link" to="/">
              <img alt="IOS OFFICES" className="brand-logo" src={brandLogo} />
            </Link>
          </div>
          <li className="navbar-toggle navbar-movil">
            <a onClick={this.props.handleLanguageChange}>
              <img
                alt={t('dashboard.img_lang')}
                src={this.props.lang === LANG.EN ? lang_es : lang_en}
                width="20px" />
            </a>
          </li>
          <li className="navbar-toggle navbar-movil">
            {notificaciones ? (
              <div className="dropdown">
                <button className="btn btn-default dropdown-toggle btn-bell" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" onClick={this.props.handleUpdateSolicitudes}>
                  <a className="btn btn-default-bell" >{notificaciones.count}</a>
                  <i className="fa fa-bell" aria-hidden="true"></i>
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenu1">
                  {notificaciones.connections.map((notificacion, index) => (
                    <div key={index}>
                      <div className="nav-link" to={'/user/' + notificacion.id}>
                        {this.renderNotificacion(notificacion)}
                      </div>
                    </div>
                  ))}
                </ul>
              </div>

            ) : (
              <a>
                <i className="fa fa-bell-o" aria-hidden="true">
                </i>
              </a>
            )}
          </li>
        </div>
        <ul className="nav navbar-top-links navbar-right navbar-desktop">
          <li>
            <a onClick={this.props.handleLanguageChange}>
              <img
                alt={t('dashboard.img_lang')}
                src={this.props.lang === LANG.EN ? lang_es : lang_en}
                width="20px" />
            </a>
          </li>
          <li className="dropdown">
            <a className="dropdown-toggle" data-toggle="dropdown">
              <img alt={t('dashboard.navbar.img_user')} src={this.props.user.picture} />&nbsp;
              <i className="fa fa-caret-down" />
            </a>
            <ul className="dropdown-menu dropdown-user">
              <li>
                <Link to="/profile">
                  <i className="fa fa-fw fa-user" />&nbsp;
                  {this.props.user.name + " " + this.props.user.lastname}
                </Link>
              </li>
              <li>
                <a href="https://www.iosoffices.com/lifestyle" rel="noopener noreferrer" target="_blank">
                  <i className="fa fa-fw fa-envelope" />&nbsp;
                  {t('dashboard.navbar.lifestyle')}
                </a>
              </li>
              <li>
                <Link to="/mejoracontinua" rel="noopener noreferrer" target="_blank">
                  <i className="fa fa-fw fa-pencil-square-o" />&nbsp;
                  {t('dashboard.navbar.survey')}
                </Link>
              </li>
              <li className="divider" />
              <li>
                <a onClick={this.props.handleLogoutClick}>
                  <i className="fa fa-fw fa-sign-out" />&nbsp;
                  {t('dashboard.navbar.logout')}
                </a>
              </li>
            </ul>
          </li>
          <li className="navbar-toggle">
            {notificaciones ? (
              <div className="dropdown">
                <button className="btn btn-default dropdown-toggle btn-bell" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" onClick={this.props.handleUpdateSolicitudes}>
                  <a className="btn btn-default-bell" >{notificaciones.count}</a>
                  <i className="fa fa-bell" aria-hidden="true"></i>
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenu1">
                  {notificaciones.connections.map((notificacion, index) => (
                    <div key={index}>
                      <div className="nav-link" to={'/user/' + notificacion.id}>
                        {this.renderNotificacion(notificacion)}
                      </div>
                    </div>
                  ))}
                </ul>
              </div>

            ) : (
              <a>
                <i className="fa fa-bell-o" aria-hidden="true">
                </i>
              </a>
            )}
          </li>
        </ul>
        {this.renderSidebar()}
      </nav>
    );
  }
}

export default translate('common')(Navbar);



// WEBPACK FOOTER //
// ./src/dashboard/Navbar.js